export default __webpack_public_path__ + "static/media/OPI_logo.e03d1b55.svg";